import Link from "@insite/mobius/Link";
import React, { FC, MouseEvent } from 'react';

interface IData {
  title: string;
  url: string;
}

interface ILinkListMenuProps {
  data: IData;
  closeMenu: (event: MouseEvent<HTMLAnchorElement>) => void;
}

const LinkListMenu: FC<ILinkListMenuProps> = ({ data, closeMenu }) => {

  const { title, url } = data;

  return (
    <li className="megaMenu__linkList-item">
      <Link className="megaMenu__linkList-link" href={url} onClick={closeMenu}>
        {title}
      </Link>
    </li>
  )
}

export default LinkListMenu;



// import Link from "@insite/mobius/Link";
// import React from 'react'

// const LinkListMenu = ({ (data: any), (closeMenu: any) }) => {

//   const { title, url} = data
//   return (
//     <li className="megaMenu__linkList-item">
//       <Link className="megaMenu__linkList-link" href={url} onClick={closeMenu}>
//         {title}
//       </Link>
//     </li>
//   )
// }

// export default LinkListMenu